export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1" d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1l-.3 90.7c0 6.9-5.6 12.5-12.5 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M30.4 88.8c2.5 0 4.4.6 5.6 1.9 1.3 1.3 1.9 3.1 1.9 5.4 0 2.3-.6 4.1-1.9 5.4-1.3 1.3-3.2 1.9-5.6 1.9h-7.5v10.1h-3.3V88.8h10.8zm-1.1 11.8c1.9 0 3.2-.4 4.1-1.1.9-.8 1.3-1.9 1.3-3.4s-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2h-6.4v9h6.4zM52.7 88.8c2.5 0 4.4.6 5.6 1.9 1.3 1.3 1.9 3.1 1.9 5.4 0 2.3-.6 4.1-1.9 5.4-1.3 1.3-3.2 1.9-5.6 1.9h-7.5v10.1h-3.3V88.8h10.8zm-1.1 11.8c1.9 0 3.2-.4 4.1-1.1.9-.8 1.3-1.9 1.3-3.4s-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2h-6.4v9h6.4zM61.7 91.6v-2.8h19.7v2.8h-8.2v21.8h-3.3V91.6h-8.2z"/>
    </g>
    <path fill="${fill ? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
</svg>`
)



// WEBPACK FOOTER //
// ./components/Icon/icons/files/ppt.jsx